module.exports = __webpack_public_path__ + "img/topPic.ffc0c12f.png";